
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const WorkAssignedTableDataAPI = createAsyncThunk("WorkAssignedTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_AssetTypeID,
        WorkAssignByM_UserID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_UploadAssignWork_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&WorkAssignByM_UserID=${WorkAssignByM_UserID ? WorkAssignByM_UserID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : '0'}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetExport && handleGetExport()
                return result.data
            } else {
                return result
            }
        })
})

const WorkAssignedTableDataSlice = createSlice({
    name: "WorkAssignedTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkAssignedTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WorkAssignedTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WorkAssignedTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WorkAssignedTableDataReducer = WorkAssignedTableDataSlice.reducer


// Get Table Data
export const Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI = createAsyncThunk("Get_WEB_GD_OfficerWisePendingWorkStatusDetails_Select", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        ToDate,
        M_WorkTypeID,
        M_AssetTypeID,
        M_WardID,
        M_ZoneID,
        WorkAssignByM_UserID,
        M_ContractorID,
        M_UserID,
        ShowBy,
        token,
        From,
        To,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_GD_OfficerWisePendingWorkStatusDetails_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&FromDate=${FromDate}&ToDate=${ToDate}&M_WorkTypeID=${M_WorkTypeID}&M_AssetTypeID=${M_AssetTypeID}&M_WardID=${M_WardID}&M_ZoneID=${M_ZoneID}&WorkAssignByM_UserID=${WorkAssignByM_UserID}&M_ContractorID=${M_ContractorID}&M_UserID=${M_UserID}&Language=Marathi&Flag=${Flag}&ShowBy=${ShowBy}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // handleGetExport && handleGetExport()
                return result.data
            } else {
                return result
            }
        })
})

const Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectSlice = createSlice({
    name: "Get_WEB_GD_OfficerWisePendingWorkStatusDetails_Select",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectReducer = Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectSlice.reducer


// Get Table Data
export const WorkAssignedExportTableDataAPI = createAsyncThunk("WorkAssignedExportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_AssetTypeID,
        WorkAssignByM_UserID,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_UploadAssignWork_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&WorkAssignByM_UserID=${WorkAssignByM_UserID ? WorkAssignByM_UserID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : '0'}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WorkAssignedExportTableDataSlice = createSlice({
    name: "WorkAssignedExportTableData",
    initialState: {
        isExportLoading: false,
        WorkAssignedExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WorkAssignedTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WorkAssignedTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.WorkAssignedExportTableData = action.payload;
        });
        builder.addCase(WorkAssignedTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.WorkAssignedExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WorkAssignedExportTableDataReducer = WorkAssignedExportTableDataSlice.reducer


